<template>
  <v-main>
    <v-container v-if="issomethingloading">
      <v-row  >
        <v-col cols="12" class="text-center">
          <v-progress-circular
                  :size="100"
                  :width="7"
                  color="primary"
                  indeterminate
          ></v-progress-circular>
        </v-col>
      </v-row>
    </v-container>


    <v-container fluid v-else-if="product">
      <head>
        <title>{{product.name}} - editing - Foraje</title>
        <meta name="description" :content="product.display_name">
      </head>
      <v-dialog v-model="productdeletedialog"
                max-width="500"
                v-if="product.vendor.id === userdetails.id"

      >
        <v-card>
              <v-card-title
                      class="headline grey lighten-2"
                      primary-title
                      style="justify-content: center"
              >
                Delete {{product.name}} ?
              </v-card-title>
          <v-card-text>
              <p>
                By clicking 'Delete', you will be forever deleting ' {{product.name}} '.
                Are you sure this is what you want to do? If not, hit Cancel, or click outside this box.
              </p>
          </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        color="red darken-1"
                        :loading="productdeleteloading"
                        :disabled="productdeleteloading"
                        @click="ProductDeactivate"
                        dark
                >
                  Delete
                  <span slot="loader" class="custom-loader">
                        <v-progress-circular indeterminate color="green"></v-progress-circular>
                       </span>
                </v-btn>
                <v-btn
                        color="primary"
                        dark
                        @click="productdeletedialog = false"
                >
                  Cancel
                </v-btn>
              </v-card-actions>
        </v-card>

      </v-dialog>
      <v-row   style="justify-content: center">
        <v-col class="pa-4" cols="12" >
          <v-card flat class="transparent">
            <v-card-text>
              <h1 style="text-align: center">Edit Your product: " <!--<router-link :to="'/products/' + product.slug">{{product.name}}</router-link>--> {{product.name}} " </h1>
              <v-btn
                      fab
                      dark
                      bottom
                      absolute
                      right
                      color="red"
                      @click="productdeletedialog = !productdeletedialog"
              >
                <v-icon>
                  mdi-delete-outline
                </v-icon>
              </v-btn>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col class="pa-4" cols="12" sm="8" >
          <v-card flat class="transparent">
            <v-card flat class="transparent">
              <v-card-title primary-title>
                <h2>Basics:</h2>
              </v-card-title>
            </v-card>
            <v-col class="pa-4" >
              <v-card>
                <v-card-title>
                  <span style="font-size: x-large">Name</span>
                </v-card-title>
                <v-card-text>
                  <v-text-field
                    name="productname"
                    label="Name"
                    hint="Just for your own purposes, we don't usually display it to customers."
                    id="productname"
                    v-model="newproductname"
                  ></v-text-field>
                </v-card-text>
                <v-card-title>
                  <v-col cols="12">
                  <span style="font-size: x-large">Price</span>
                  </v-col>
                  <v-col class="pa-2" cols="12">
                    <span style="font-size: large">Current Price: {{product.price.slice(0, -2)}} per {{product.price_units}}</span>
                  </v-col>
                </v-card-title>
                <v-card-text>

                  <v-text-field
                          name="price"
                          label="Product Price*"
                          hint="4.99, 125.00, etc."
                          id="price"
                          required
                          v-model="newproductprice"
                          prefix="$"
                          min="0"
                          step=".01"
                          type="number"
                  ></v-text-field>
                  <v-text-field
                          name="units"
                          label="Product Units*"
                          hint="How many units are you selling for the selected price? ie. per lb, per 100 seeds, per 10 kg, each etc."
                          id="units"
                          required
                          v-model="newproductpriceunits"
                          prefix="per"
                  ></v-text-field>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col class="pa-4" >
              <v-card>
                <v-card-title>
                  <span style="font-size: x-large">Are you still selling this product?</span>
                </v-card-title>
                <v-card-text>
                  <v-radio-group v-model="product.currently_have">
                    <v-radio
                            label="I still have this Product"
                            :value="true"
                            color="primary"
                    >

                    </v-radio>
                    <v-radio
                            label="I no longer have this Product, or it's out of stock"
                            :value="false"
                            color="primary"
                    >

                    </v-radio>
                  </v-radio-group>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col class="pa-4" >
              <v-card>
                <v-card-title>
                  <v-col cols="12">
                    <span style="font-size: x-large">Where does this product ship from?</span>
                    <p style="font-size: small; white-space: nowrap;"> (If it ships at all, if not, just leave it blank, or select a location where it can be picked up/purchased)</p>
                  </v-col>
                  <v-col class="pa-2" >
                    <span style="font-size: large;">Current Shipping Location: {{product.shipping_location.name}}</span>
                  </v-col>
                </v-card-title>
                <v-card-text>
                  <v-row >
                    <v-col>
                      <v-select
                              name="shippinglocation"
                              label="Where does it ship from?"
                              hint="One of your saved shipping locations, or add information specific to this Product"
                              id="shippinglocation"
                              v-model="newshippinglocation"
                              :items="usersshippinglocations"
                              item-text="name"
                              return-object
                              required
                      ></v-select>
                    </v-col>
                    <v-dialog v-model="addshiplocdialog" max-width="600px">
                      <template v-slot:activator="{ on }">
                      <v-btn fab small v-on="on" dark color="primary">
                        <v-icon dark>mdi-plus</v-icon>
                      </v-btn>
                      </template>
                      <CreateShippingLocation v-on:close-newshiploc="NewShipLoc"></CreateShippingLocation>
                    </v-dialog>
                  </v-row>


                </v-card-text>
              </v-card>
            </v-col>
          </v-card>
        </v-col>


        <v-col class="pa-4" cols="12" sm="8" >
          <v-card flat class="transparent">
            <v-card-title>
              <h2>Extras:</h2>
            </v-card-title>
          </v-card>
          <v-col class="pa-4" cols="12" >
          <v-card>
            <v-card-text>
              <v-col class="pb-4" >
                <v-col class="pb-2" >
                <span style="font-size: x-large">SKU</span>
              </v-col>
              <v-col class="pa-2" >
                <span style="font-size: medium">Current SKU: {{product.sku}}</span>
              </v-col>

              <v-text-field
                      name="sku"
                      label="SKU"
                      hint="Just for your own purposes and tracking, we don't do anything with it"
                      id="sku"
                      v-model="newsku"
              ></v-text-field>
              </v-col>
              <v-col class="pb-4" >
              <v-col>
                <span style="font-size: x-large">Inventory</span>
              </v-col>
              <v-col class="pa-2" >
                <span style="font-size: large">Current Inventory: {{product.inventory}}</span>
              </v-col>
              <v-text-field
                      name="inventory"
                      label="Inventory"
                      hint="How many do you have in stock?"
                      id="inventory"
                      v-model="newinventory"
                      min="0"
                      type="number"
                      default="0"
              ></v-text-field>
              </v-col>
              <v-col class="pb-4" >
              <v-col>
                <span style="font-size: x-large">External Page</span>
              </v-col>
              <v-col class="pa-2" >
                <span style="font-size: large">Current URL: {{product.external_page}}</span>
              </v-col>
              <v-text-field
                      name="externalurl"
                      label="External URL"
                      hint="A link to another page that has this product for sale, possibly on your own site"
                      id="externalurl"
                      v-model="newexternalurl"
                      type="url"
                      placeholder="https://www.mysite.com/myproduct.html"
              ></v-text-field>
              </v-col>
              <v-col class="pb-4" >
              <v-col>
                <span style="font-size: x-large">Harvest Date</span>
              </v-col>
              <v-col class="pa-2" >
                <span style="font-size: large" v-if="product.harvest_time && product.harvest_time.length">Current Harvest Date: {{product.harvest_time.split('T')[0]}}</span>
                <span style="font-size: large" v-else>No Current Harvest Date / Harvest Date Unknown</span>
              </v-col>


              <v-menu
                      :close-on-content-click="false"
                      v-model="datepickermenu"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
              >
                <template v-slot:activator="{ on }">
                <v-text-field
                        v-on="on"
                        v-model="newharvesttime"
                        color="primary"
                        label="Harvest Date"
                        hint="When was this product harvested?"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        readonly
                ></v-text-field>
                </template>
                <v-date-picker v-model="newharvesttime" @input="datepickermenu = false">
                </v-date-picker>
              </v-menu>
              </v-col>

            </v-card-text>
          </v-card>
        </v-col>
        </v-col>

        <v-col cols="12" sm="8">
          <v-card flat class="transparent">
            <v-card-text style="text-align: center">
              <p style="font-size: large">Submit the changes, or cancel and go back to the previous page without saving any of these changes</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="CancelProductEdit">Cancel</v-btn>
              <v-btn color="primary" @click="SubmitProductChanges" :loading="editsubmitloading">Submit
                <span slot="loader" class="custom-loader">
                        <v-progress-circular indeterminate color="green"></v-progress-circular>
                       </span>
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

  </v-main>
</template>

<script>
import axios from 'axios';

// shipping locations component
import CreateShippingLocation from '../locations/shipping/CreateShippingLocation.vue';


export default {
  name: 'EditProduct',
  data: () => ({
    product: [],
    productimages: [],
    errors: [],
    dialog: false,
    selectedFile: null,
    productimagedialog: false,
    imagesubmitloading: false,
    /* cropimagesubmittedalert: false,
      cropitems: [],
      crop: [],
      changecropdialog: false,
      changecroploading: false,
      cropisgonnabechanged: false, */
    islocationloading: false,
    issomethingloading: false,
    productdeletedialog: false,
    productdeleteloading: false,

    currentlyhaveradio: false,
    newproductname: '',
    newproductprice: '',
    newproductpriceunits: '',
    newinventory: 0,

    newsku: '',
    newexternalurl: '',

    newharvesttime: '',
    datepickermenu: false,
    userdetails: [],


    usersshippinglocations: [],
    addshiplocdialog: false,

    editsubmitloading: false,

    /* changecomponentdialog: false,
      changecomponentloading: false,
      componentisgonnabechanged: false,
      arevarietycomponentsloading: false,
      availablevarietycomponents: [],
      newcomponent: '', */


  }),
  components: { CreateShippingLocation },

  // Fetches product info when the component is created.

  created() {
    this.getCurrentUser();
    this.GetProductData();
    this.GetUserShippingLocations();
  },

  computed: {
    userIsAuthenticated() {
      return this.$store.getters.token;
    },
    convertedharvestdatetime() {
      if (this.newharvesttime) {
        return new Date(this.newharvesttime);
      }
      return '';
    },
    /* slug(){
        if (this.newcomponent.id === this.product.component.id)
          return this.product.slug;
        else return this.slug = '';
      } */
  },
  methods: {
    getCurrentUser() {
      const authheader = `Token ${this.$store.getters.token}`;
      return axios.get('profile/details/',
        {
          headers: {
            Authorization: authheader,
          },
        })
        .then((response) => {
          this.userdetails = response.data;
        });
    },
    GetProductData() {
      this.issomethingloading = true;
      const productslug = this.$route.params.slug;
      return axios.get(`/allproducts/${productslug}/`)
        .then((response) => {
          this.product = response.data;
          this.newproductname = response.data.name;
          this.newproductprice = response.data.price.slice(0, -2);
          this.newproductpriceunits = response.data.price_units;
          this.newsku = response.data.sku;
          this.newinventory = response.data.inventory;
          this.newexternalurl = response.data.external_page;
          this.newshippinglocation = response.data.shipping_location;

          if (response.data.harvest_time && response.data.harvest_time.length) {
            [this.newharvesttime] = response.data.harvest_time.split('T');
          }


          if (response.data.vendor.id !== this.userdetails.id) {
            this.$router.push('/sign_in');
          }
        })
        .then(() => {
          this.issomethingloading = false;
        })
        .catch((error) => {
          this.$parent.$emit('alert-emitted', {
            alert_icon: 'mdi-emoticon-frown-outline', alert_color: 'error', alert_message: 'Something went wrong when retrieving this products information. We\'ll fix it, sorry for the hassle.', alert_model: true,
          });
        });
    },

    ProductDeactivate() {
      this.productdeleteloading = true;
      const authheader = `Token ${this.$store.getters.token}`;
      const productid = this.product.id;
      if (this.userdetails.id === this.product.vendor.id) {
        return axios.patch(`forms/edit/products/update/${productid}`, {
          is_active: false,
        },
        {
          headers: {
            Authorization: authheader,
          },
        })
          .then(() => {
            this.productdeleteloading = false;
            this.productdeletedialog = false;
          })
          .then(() => {
            if (!this.$store.getters.error) {
              this.$router.push(`/profiles/${this.userdetails.slug}/products/`);
              this.$parent.$emit('alert-emitted', {
                alert_icon: 'mdi-check-circle', alert_color: 'success', alert_message: 'Product Deleted', alert_model: true,
              });
            }
          })
          .catch((error) => {
            this.$parent.$emit('alert-emitted', {
              alert_icon: 'mdi-emoticon-frown-outline', alert_color: 'error', alert_message: 'Something went wrong with deleting this Product.', alert_model: true,
            });
          });
      } return this.$parent.$emit('alert-emitted', {
        alert_icon: 'mdi-emoticon-frown-outline', alert_color: 'error', alert_message: 'Something went wrong. Are you sure you\'re allowed to delete this product?', alert_model: true,
      });
    },

    SubmitProductChanges() {
      const authheader = `Token ${this.$store.getters.token}`;
      const productid = this.product.id;
      if (this.userdetails.id === this.product.vendor.id) {
        this.editsubmitloading = true;
        const productdata = this.removeEmptyStrings({
          name: this.newproductname,
          currently_have: this.product.currently_have,
          shipping_location: this.newshippinglocation.id,
          price: this.newproductprice,
          price_units: this.newproductpriceunits,
          external_page: this.newexternalurl,
          sku: this.newsku,
          inventory: this.newinventory,
          harvest_time: this.convertedharvestdatetime,
        });
        return axios.patch(`forms/edit/products/update/${productid}`, productdata,
          {
            headers: {
              Authorization: authheader,
            },
          })
          .then(() => {
            this.editsubmitloading = false;
            this.$parent.$emit('alert-emitted', {
              alert_icon: 'mdi-check-circle', alert_color: 'success', alert_message: `Product '${this.newproductname}' changed!`, alert_model: true,
            });
          })
          .then(() => {
            this.$router.push('/user/my-products/');
          })
          .catch((error) => {
            this.$parent.$emit('alert-emitted', {
              alert_icon: 'mdi-emoticon-frown-outline', alert_color: 'error', alert_message: 'Something went wrong with changing this Product.', alert_model: true,
            });
          });
      } return this.$parent.$emit('alert-emitted', {
        alert_icon: 'mdi-emoticon-frown-outline', alert_color: 'error', alert_message: 'Something went wrong. Are you sure you\'re allowed to edit this product?', alert_model: true,
      });
    },

    /* GetCrops(){
        this.changecropdialog = !this.changecropdialog;
        if(this.cropitems.length === 0) {
          axios.get('barebones/baseproduct/by/producer/' + this.currentUser.pk + '/')
                  .then(response => {
                    this.cropitems = response.data;
                    this.issomethingloading = false;
                  })
                  .catch(e => {
                    this.errors.push(e)
                  });
        }
      },
      GetAvailableVarietyComponents(){
                  this.changecomponentdialog = !this.changecomponentdialog;
                  this.arevarietycomponentsloading = true;
                  this.availablevarietycomponents = [];
                  this.newcomponent = '';
                  let croptocheck = this.crop.id;
                  return axios.get('filtered/component/by/base_product/' + croptocheck + '/')
                          .then(response => {
                            this.availablevarietycomponents = response.data;
                          })
                          .then(() => {
                            this.arevarietycomponentsloading = false;
                          })
      },

      SetNewCrop(){
        this.cropisgonnabechanged = true;
        this.changecropdialog = false;
        this.GetAvailableVarietyComponents();
      },

      SetNewProductType(){
        this.componentisgonnabechanged = true;
        this.changecomponentdialog = false;
      }, */

    CancelProductEdit() {
      this.$router.go(-1);
    },

    removeEmptyStrings(obj) {
      const newObj = {};
      Object.keys(obj).forEach((prop) => {
        if (obj[prop] !== '') { newObj[prop] = obj[prop]; }
      });
      return newObj;
    },

    GetUserShippingLocations() {
      const authheader = `Token ${this.$store.getters.token}`;
      // get this users shipping locations
      axios.get('filtered/shippinginfo/by/owner/', {
        headers: {
          Authorization: authheader,
        },
      })
        .then((response) => {
          this.usersshippinglocations = response.data;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    NewShipLoc() {
      this.GetUserShippingLocations();
      this.$parent.$emit('alert-emitted', {
        alert_icon: 'mdi-check-circle', alert_color: 'success', alert_message: 'New Shipping Location Added!', alert_model: true,
      });
      this.addshiplocdialog = false;
    },
  },

};

</script>

<style scoped>


  img {

    display: flex;
    max-height: 600px;
    max-width: 600px;
    object-fit: contain;
    min-width: available;

  }
  .BasicInfo{
    display:inline-flex;
    vertical-align: top;
  }
  .Photo{
    vertical-align: top;
    object-fit: contain;
    display: flex;

  }
  .QuickLook{
    display:flex;
    max-width: 400px;
  }
  .Vendors{
    display: flex;
    vertical-align: top;
    max-width: 500px;

  }
  .Description{
    display: flex;
    vertical-align:top;
  }
  .bigFont li{
    font-size:16px;
  }
  .map{
    height: 400px;
    margin: 0;
  }
</style>
